const CoverSchema = {
  title: 'Cover',
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['image', 'title', 'subtitle', 'link'],
    },
  ],
  properties: {
    image: {
      title: 'Background Image',
      description: 'Upload an image for the background',
      type: 'string',
      widget: 'image',
    },
    title: {
      title: 'Title',
      type: 'string',
    },
    subtitle: {
      title: 'Subtitle',
      type: 'string',
    },
    learnMoreUrl: {
      title: 'Learn More URL',
      type: 'string',
      description: 'URL for the Learn More button',
    },
    link: {
      title: 'Link',
      widget: 'object_browser',
      mode: 'link',
      selectableTypes: ['Document'],
    }
  },
  required: ['image', 'title', 'subtitle', 'link'],
};

export default CoverSchema;
